import { Divider, Title } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';

import CorporationHometaxGuide from './CorporationHometaxGuide';
import CorporationHometaxList from './CorporationHometaxList';
import CorporationJointCertificateGuide from './CorporationJointCertificateGuide';
import CorporationJointCertificateList from './CorporationJointCertificateList';

import { useInvalidOSDialog } from '@/components/tax-refund/common/hooks/use-invalid-os-dialog';
import { CORPORATION_PATHS } from '@/lib/constants/paths';
import useDetectOs from '@/lib/hooks/use-detect-os';

const CorporationSelectAuthContent = () => {
  const router = useRouter();
  const detectOS = useDetectOs();
  const { showInvalidOSDialog } = useInvalidOSDialog();

  const handleClickJointCertificate = () => {
    if (detectOS !== 'windows') {
      showInvalidOSDialog();
      return;
    }

    router.push({
      pathname: `${CORPORATION_PATHS.법인공동인증서프로그램설치판단}`,
      query: router.query
    });
  };

  const handleClickHometax = () => {
    router.push({
      pathname: `${CORPORATION_PATHS.홈택스아이디입력}`,
      query: router.query
    });
  };

  return (
    <>
      <div className="page-padding flex w-full flex-col">
        <Title.Headline title="어떤 방법으로 조회할까요?" size="large" />
        <div className="pb-8" />
        {detectOS === 'windows' ? (
          <CorporationJointCertificateGuide handleClick={handleClickJointCertificate} />
        ) : (
          <CorporationHometaxGuide handleClick={handleClickHometax} />
        )}
      </div>

      <div className="pb-6" />
      <Divider.Section />
      <div className="pb-4" />

      {detectOS === 'windows' ? (
        <CorporationHometaxList handleClick={handleClickHometax} />
      ) : (
        <CorporationJointCertificateList handleClick={handleClickJointCertificate} />
      )}
    </>
  );
};

export default CorporationSelectAuthContent;
